import React, { useMemo, useState } from "react";
import Stack from "@mui/material/Stack";
import Badge from "@mui/material/Badge";
import {
  AlertComponent,
  SearchInputComponent,
} from "../../../../../../../common/components";
import FilterIcon from "../../../../../../../assets/icons/filter-icon.svg";
import { LeadFilterProps } from "../../../../../../leads/lead-filter/lead-filter.props";
import "../../../../../../leads/lead-filter/lead-filter.scss";
import { useNavigate } from "react-router-dom";
import { useResourcePermissions } from "../../../../../../../common/hooks/resource-permissions";
import MODULES from "../../../../../../../constants/modules";
import { useSetLoading } from "../../../../../../../common/hooks/appearance";

const AddLeadFilter: React.FC<LeadFilterProps> = (props: any) => {
  const {
    isOpenFilter,
    setIsOpenFilter,
    selectedLeadsFilter,
    onSearch,
    searchRef,
    isResetSearch,
    showNextButton,
    setOpenStatusDialog,
  } = props;
  const navigate = useNavigate();
  const { canRead, canWrite, canDelete } = useResourcePermissions(
    MODULES.LEAD_DETAILS
  );
  const [alertMessage, setAlertMessage] = useState<string | null>(null);
  const [alertType, setAlertType] = useState<
    "error" | "success" | "info" | "warning"
  >("info");
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const handleAlertClose = () => {
    setAlertOpen(false);
  };
  const showLoading = useMemo(() => loading, [loading]);
  useSetLoading(showLoading);

  return (
    <div className="lead-list-search-filter-wrapper">
      <div className="lead-list-search-wrapper">
        <SearchInputComponent
          placeholder="Search by Lead name, Email, Lead owner etc."
          onSearch={onSearch}
          isReset={isResetSearch}
          ref={searchRef}
        />
      </div>
      <div className="lead-list-filter-wrapper">
        {/* <div className="lead-list-lead-filter">
          <SelectInputComponent
            fieldName={"allLeads"}
            value={[selectedAllLeads || "All Leads"]}
            onChange={(e: any) => setSelectedAllLeads(e)}
            multiple={false}
            options={allLeadsOptions}
          />
        </div> */}
        <div
          className="lead-list-icon-filter"
          onClick={() => setIsOpenFilter(!isOpenFilter)}
          tabIndex={0}
        >
          <Stack spacing={4} direction="row" sx={{ color: "action.active" }}>
            <Badge
              color="secondary"
              sx={{
                "& .MuiBadge-badge": {
                  backgroundColor: "#887952",
                },
              }}
              badgeContent={selectedLeadsFilter}
            >
              <img src={FilterIcon} alt="Filter Icon" />
            </Badge>
          </Stack>
        </div>
        {canWrite && (
          <div className="lead-list-create-filter">
            <button
              className="custom-button-two"
              onClick={() => props.setIsShowCreateLead(true)}
            >
              New Lead
            </button>
          </div>
        )}
        {showNextButton && (
          <div className="lead-list-next-button-wrapper">
            <button
              className="custom-button-two custom-button-next"
              onClick={() => props.setOpenStatusDialog(true)}
            >
              Next
            </button>
          </div>
        )}
      </div>
      <AlertComponent
        message={alertMessage}
        type={alertType}
        open={alertOpen}
        onClose={handleAlertClose}
      />
    </div>
  );
};

export default AddLeadFilter;
